import { LANG_LABEL, UI_LANGS, useT, type UiLang } from "../../lib/i18n";

/**
 * 后台界面语言下拉。顶栏和登录页共用。
 *
 * 以前是中英二选一的按钮（显示「切过去会变成什么」）；加了日语后改成下拉：
 * 三种语言轮转的话，中文界面上按钮写着「EN」，要连点两下才到日语，看起来像没有日语。
 * 下拉里每种语言用它自己的写法，不懂当前界面语言的人也认得出要点哪个。
 */
export function LangSwitch({ value, onChange }: { value: UiLang; onChange: (v: UiLang) => void }) {
  const t = useT();
  return (
    <select title={t("top.switchLang")} aria-label={t("top.switchLang")} value={value}
      onChange={(e) => onChange(e.target.value as UiLang)}
      className="h-control-sm cursor-pointer rounded-base border border-line bg-white px-1.5 text-sm text-ink-regular hover:border-primary hover:text-primary">
      {UI_LANGS.map((l) => <option key={l} value={l}>{LANG_LABEL[l]}</option>)}
    </select>
  );
}
